import { render, staticRenderFns } from "./browse-category-mobile.vue?vue&type=template&id=095156bc&scoped=true"
import script from "./browse-category-mobile.vue?vue&type=script&lang=js"
export * from "./browse-category-mobile.vue?vue&type=script&lang=js"
import style0 from "./browse-category-mobile.vue?vue&type=style&index=0&id=095156bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095156bc",
  null
  
)

export default component.exports